module.exports = __webpack_public_path__ + "img/kefu-icon@2x.60f495c8.png";